// extracted by mini-css-extract-plugin
export default {"error-403":"styles_error-403__k1sHt","error-title":"styles_error-title__QbS9Q"};